<div *ngIf="selectedTicket" class="project-progress card">
    <div class="project-progress-header">
        <div>
            <div class="project-progress-title">Project Progress</div>

            <!-- One project reads as a label; several become a picker -->
            <div *ngIf="tickets.length === 1" class="project-name">
                {{ selectedTicket.title }}
                <span class="project-number text-muted">{{ selectedTicket.ticketNumber }}</span>
            </div>
            <select *ngIf="tickets.length > 1"
                    class="form-select form-select-sm project-picker"
                    [ngModel]="selectedTicket.salesTicketId"
                    (ngModelChange)="onTicketPicked($event)">
                <option *ngFor="let ticket of tickets" [value]="ticket.salesTicketId">
                    {{ ticket.title }} ({{ ticket.ticketNumber }})
                </option>
            </select>
        </div>

        <div *ngIf="selectedTicket.importance === 'High'" class="badge bg-danger align-self-start">HIGH</div>
    </div>

    <!-- Timeline -->
    <div class="project-timeline" *ngIf="steps.length > 0">
        <div *ngFor="let step of steps; let last = last"
             class="project-step"
             [class.done]="step.state === 'done'"
             [class.current]="step.state === 'current'"
             [class.todo]="step.state === 'todo'">
            <!-- Reached steps take the theme's success colour via its own utility classes -->
            <div class="project-step-track">
                <div class="project-step-icon"
                     [class.bg-success]="step.state !== 'todo'"
                     [class.text-white]="step.state !== 'todo'"
                     [title]="step.name">
                    <i class="bi" [ngClass]="step.icon"></i>
                </div>
                <div *ngIf="!last" class="project-step-line" [class.bg-success]="step.state === 'done'"></div>
            </div>
            <div class="project-step-label">{{ step.name }}</div>
            <div class="project-step-date text-muted">
                <span *ngIf="step.date">{{ step.date | date:'MMM d' }}</span>
            </div>
        </div>
    </div>

    <!-- Stage / next step / progress / detail -->
    <div class="project-status">
        <div class="project-status-stage">
            <div class="mb-3">
                <b>Current Stage:</b>
                <span class="project-current-stage" [ngClass]="selectedTicket.isClosed ? 'text-success' : 'text-primary'">
                    {{ selectedTicket.isClosed ? 'Complete' : (currentStep?.name || selectedTicket.stageName) }}
                </span>
            </div>

            <div *ngIf="nextStep" class="project-next-step">
                <b>Next Step</b>
                <div class="d-flex align-items-center flex-wrap gap-2 mt-1">
                    <span>{{ nextStep.text }}</span>
                    <button *ngIf="nextStep.buttonLabel"
                            type="button"
                            class="btn btn-outline-secondary btn-sm project-next-button"
                            (click)="nextStep.action()">
                        <i class="bi" [ngClass]="nextStep.buttonIcon"></i> {{ nextStep.buttonLabel }}
                    </button>
                </div>
            </div>
        </div>

        <div class="project-ring">
            <svg viewBox="0 0 120 120" width="120" height="120" aria-hidden="true">
                <defs>
                    <linearGradient id="projectRingGradient" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0" stop-color="#c026d3" />
                        <stop offset="1" stop-color="#2563eb" />
                    </linearGradient>
                </defs>
                <circle class="project-ring-track" cx="60" cy="60" r="52" />
                <circle class="project-ring-value" cx="60" cy="60" r="52"
                        stroke="url(#projectRingGradient)"
                        [attr.stroke-dasharray]="ringCircumference"
                        [attr.stroke-dashoffset]="ringOffset" />
            </svg>
            <div class="project-ring-label">
                <small class="text-muted">PROGRESS</small>
                <div class="project-ring-percent text-primary">{{ progressPercent }}%</div>
            </div>
        </div>

        <div class="project-detail-link">
            <button *ngIf="canOpenBoard" type="button" class="btn btn-outline-secondary btn-lg" (click)="goToProjectDetail()">
                Go to Project Detail
            </button>
        </div>
    </div>

    <!-- Related documents -->
    <div class="project-documents">
        <div class="project-progress-title">Related Documents</div>

        <table class="table table-sm project-documents-table">
            <thead>
                <tr>
                    <th></th>
                    <th class="text-primary">Date</th>
                    <th class="text-primary">Activity</th>
                    <th class="text-primary">Document</th>
                    <th class="text-primary text-center">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let row of rows"
                    [class.project-row-continued]="!row.first"
                    [class.project-row-link]="!!row.documentId"
                    (click)="onRowClicked(row)">
                    <td class="project-row-step">
                        <ng-container *ngIf="row.first">
                            <i class="bi" [ngClass]="row.icon"></i>
                            <b>{{ row.stepName }}</b>
                        </ng-container>
                    </td>
                    <td>{{ row.date | date:'MMM d, y' }}</td>
                    <td>{{ row.activity }}</td>
                    <td>
                        <a *ngIf="row.documentId" role="button" class="text-primary">{{ row.documentLabel }}</a>
                    </td>
                    <td class="text-center">
                        <ng-container *ngIf="row.first">
                            <i *ngIf="row.state === 'done'" class="bi bi-check-circle-fill text-success project-row-status"></i>
                            <i *ngIf="row.state === 'current'" class="bi bi-record-circle-fill text-primary project-row-status"></i>
                            <i *ngIf="row.state === 'todo'" class="bi bi-circle project-row-status project-row-status-todo"></i>
                        </ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
